import { render, staticRenderFns } from "./MarketFooter.vue?vue&type=template&id=1dfedc20&scoped=true"
import script from "./MarketFooter.vue?vue&type=script&lang=js"
export * from "./MarketFooter.vue?vue&type=script&lang=js"
import style0 from "./MarketFooter.vue?vue&type=style&index=0&id=1dfedc20&prod&lang=scss"
import style1 from "./MarketFooter.vue?vue&type=style&index=1&id=1dfedc20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dfedc20",
  null
  
)

export default component.exports